<template>
  <div id="home">
    <Header />
    <Navigation />
    <About />
    <Clients />
    <News />
    <Internet />
    <Phone/>
    <Packages/>
    <Tv/>
    <CompanyServices />
    <Event />
    <Contact />
    <Fooder />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Navigation from "@/components/Navigation.vue";
import About from "@/components/About.vue";
import Clients from "@/components/Clients.vue";
import Internet from "@/components/Internet.vue";
import Phone from "@/components/Phone.vue";
import Packages from "@/components/Packages.vue";
import Tv from "@/components/Tv.vue";
import CompanyServices from "@/components/CompanyServices.vue";
import Event from "@/components/Event.vue";
import News from "@/components/News.vue";
import Contact from "@/components/Contact.vue";
import Fooder from "@/components/Fooder.vue";

export default {
  name: "home",
  components: {
    Header,
    Navigation,
    About,
    Clients,
    Internet,
    Phone,
    Packages,
    Tv,
    CompanyServices,
    Event,
    News,
    Contact,
    Fooder
  }
};
</script>

